module.exports = __webpack_public_path__ + "img/shooting_04.1403ea3c.jpg";